import { AppNavigation } from '@BUP/navigations';
import {
  LoginPage,
  SignUpPage,
  PasswordResetPage
} from '@BUP/pages';
import {
  Switch,
  Redirect
} from 'react-router-dom';
import {
  PublicRoute,
  PrivateRoute
} from '@BUP/routes';

const AuthNavigation = () => {
  return (
    <Switch>
      <PublicRoute
        restricted={true}
        component={LoginPage}
        path="/login" exact
      />
      <Redirect strict from="/invitation/code/:code" to="/signup/code/:code" />
      <PublicRoute
        restricted={true}
        component={SignUpPage}
        path="/signup/code/:code"
      />
      <PublicRoute
        restricted={true}
        component={PasswordResetPage}
        path="/password-reset" exact
      />
      <PrivateRoute
        component={AppNavigation}
        path="/"
      />
    </Switch>
  )
}

export default AuthNavigation;